<template>
  <div id="entry-view">
  <entry-side-view
    :isSidebarActive="entrySidebarActive"
    @closeSidebar="toggleDataSidebar"
    :data="sideBarEntryData"
    :mrmrStatementHeaderId="model.id"
    :statementEntries="model.entries"
    :previousStatementEntries="previousStatementEntries"
    @onEntryUpdated="entryUpdated"
    @onEntryInserted="entryInserted"
  />

    <div class="vx-col w-full mb-base">
      <vx-card ref="infoCard" :title="cardTitle" title-color="black">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
          <vs-button type="border" class="mr-3" icon-pack="feather" icon="icon-save" @click="saveData" v-b-tooltip.hover :title="$t('Save')">{{ $t('Save') }}</vs-button>
          <vs-button type="border" class="mr-3" color="danger" @click="returnToList" v-b-tooltip.hover :title="$t('Cancel')">{{ $t('Cancel') }}</vs-button>
          <vs-button v-if="!isNew" type="border" class="mr-3" icon-pack="feather" icon="icon-upload"  @click="openUploadPopup" v-b-tooltip.hover :title="$t('Upload')">{{ $t('Upload') }}</vs-button>
          <vs-button v-if="!isNew" type="border" icon-pack="feather" icon="icon-check-circle"  @click="confirmSubmit" v-b-tooltip.hover :title="$t('Submit')">{{ $t('Submit') }}</vs-button>
          </vs-col>
        </vs-row>
        <ValidationObserver ref="observer">
          <vs-tabs v-model="selectedTab">
            <vs-tab value="0" :label="$t('MRMR.Statement.Tab1')" icon-pack="feather" icon="icon-settings">
              <div class="p-6">
                <vs-row class="mb-3">
                  <vs-col vs-w="6" class="mr-5">
                    <form-label>{{ $t('MRMR.Statement.Project') }}</form-label>
                    <ValidationProvider :name="$t('MRMR.Statement.Project')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="name"
                      append-to-body
                      :options="projects"
                      v-model="model.projectId"
                      :reduce="p => p.id"
                      class="w-full"
                    />
                      <validation-message>{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                  <vs-col vs-w="5">
                    <form-label>{{ $t('MRMR.Statement.Period') }}</form-label>
                    <ValidationProvider :name="$t('MRMR.Statement.Period')" rules="required" v-slot="{ errors }">
                    <v-select
                      label="name"
                      append-to-body
                      :options="sortedPeriods"
                      v-model="model.mrmrStatementPeriodId"
                      :reduce="p => p.id"
                      class="w-full"
                    />
                      <validation-message>{{ errors[0] }}</validation-message>
                    </ValidationProvider>
                  </vs-col>
                </vs-row>
                <vs-row class="mb-3">
                  <vs-col vs-w="6" class="mr-5">
                  <form-label>{{$t('MRMR.Statement.QPEngineering')}}</form-label>
                  <v-select
                    label="name"
                    append-to-body
                    :options="sortedQpEngineers"
                    v-model="model.engineerQPId"
                    :reduce="qp => qp.id"
                    :disabled="statementUnknownQpEngineering"
                    class="w-full"
                  />
                    <vs-checkbox v-model="statementUnknownQpEngineering" class="mt-2">{{ $t('Unknown') }}</vs-checkbox>
                  </vs-col>
                  <vs-col vs-w="5">
                  <form-label>{{$t('MRMR.Statement.QPGeology')}}</form-label>
                  <v-select
                    label="name"
                    append-to-body
                    :options="sortedQpGeologists"
                    v-model="model.geologistQPId"
                    :reduce="qp => qp.id"
                    :disabled="statementUnknownQpGeology"
                    class="w-full"
                  />
                    <vs-checkbox v-model="statementUnknownQpGeology" class="mt-2">{{ $t('Unknown') }}</vs-checkbox>
                  </vs-col>
                </vs-row>
                <vs-row class="mb-3">
                  <vs-col vs-w="6" class="mr-5">
                    <vs-row class="mb-3">
                      <vs-col vs-w="2" class="mr-5">
                        <ValidationProvider :name="$t('MRMR.Statement.Ownership')" rules="required" v-slot="{ errors }">
                        <validated-input
                          :label="$t('MRMR.Statement.Ownership')"
                          v-model="model.ownership"
                        ></validated-input>
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                     <vs-col vs-w="5" >
                      <form-label>{{$t('MRMR.Statement.CoreLoggingDatabaseClosureDate')}}</form-label>
                      <ValidationProvider :name="$t('MRMR.Statement.CoreLoggingDatabaseClosureDate')" rules="required" v-slot="{ errors }">
                         <datepicker format="yyyy-MM-dd"
                                  class="mr-4"
                                  v-model="model.coreLoggingDatabaseClosureDate"></datepicker>
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <form-label>{{$t('MRMR.Statement.MetallurgicalRecovery')}}</form-label>
                    </vs-row>
                    <vs-row class="mb-3">
                      <vs-col vs-w="2" class="pr-1 mt-10">
                        {{ $t("MRMR.MiningType." + miningTypeEnum.OpenPit) }}                        
                      </vs-col>
                      <vs-col vs-w="10" class="pr-1">
                        <span class="metallurgical-recovery pr-2" v-for="(item, index) in model.metallurgicalRecoveries.filter(_ => _.miningType === miningTypeEnum.OpenPit)" v-bind:key="index">
                          <ValidationProvider  :name="getElementName(item.element)" :vid="'op' + index"
                            :rules="metallurgicalRecoveryRules(item)" v-slot="{ errors }">
                              <validated-input :label="getElementName(item.element)"
                                v-model="item.percentage" :disabled="item.nonApplicable"></validated-input>
                              <validation-message>{{ errors[0] }}</validation-message>
                              <vs-checkbox v-model="item.nonApplicable" class="mt-2">{{ $t('NA') }}</vs-checkbox>
                          </ValidationProvider>
                        </span>
                      </vs-col>
                    </vs-row>
                    
                    <vs-row class="mb-2">
                      <vs-col vs-w="2" class="pr-1 mt-10 ">
                        {{ $t("MRMR.MiningType." + miningTypeEnum.Underground) }}                        
                      </vs-col>
                      <vs-col vs-w="10" class="pr-1">
                        <span class="metallurgical-recovery pr-2" v-for="(item, index) in model.metallurgicalRecoveries.filter(_ => _.miningType === miningTypeEnum.Underground)" v-bind:key="index">
                          <ValidationProvider  :name="getElementName(item.element)" 
                            :rules="metallurgicalRecoveryRules(item)" v-slot="{ errors }">
                              <validated-input :label="getElementName(item.element)"
                                v-model="item.percentage" :disabled="item.nonApplicable"></validated-input>
                              <validation-message>{{ errors[0] }}</validation-message>
                              <vs-checkbox v-model="item.nonApplicable" class="mt-2">{{ $t('NA') }}</vs-checkbox>
                          </ValidationProvider>
                        </span>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mb-3">
                      <vs-col vs-w="12">
                      <form-label>{{$t('MRMR.Statement.Notes')}} </form-label>                      
                      <feather-icon
                        icon="InfoIcon"
                        class="p-1 inline-flex cursor-pointer"
                        svgClasses="h-5 w-5"
                        v-on:mouseover="showFootnotesInstructions"
                      ></feather-icon>                      
                      <vs-alert :active.sync="footnotesPopupActive" class="mb-2" closable icon-pack="feather" close-icon="icon-x">
                          <span>
                          {{$t('MRMR.Statement.NotesHelperLine1')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine2')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine3')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine4')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine5')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine6')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine7')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine8')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine9')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine10')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine11')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine12')}}<br/><br/>
                          {{$t('MRMR.Statement.NotesHelperLine13')}}
                          </span>
                        </vs-alert>
                      <vs-textarea 
                        v-model="model.notes"
                        v-if="selectedNotesVersion === model.version"
                        class="w-full notes-mb-none"  
                        height="300px"
                        name="notes" />
                      <vs-textarea
                        v-model="selectedPreviousVersionNote"
                        v-else              
                        :disabled="true"
                        class="w-full notes-mb-none notes-read-only"  
                        height="300px"/>
                      </vs-col>
                      <vs-row>
                      <vs-tabs alignment="right" v-model="selectedNoteIndex" >
                        <vs-tab  v-for="(note, index) in allNoteVersions" :key="index" :label="String(note.version)" @click="onNotesVersionClicked(note.version)" v-b-tooltip.hover :title="$t('MRMR.Statement.Notes') + ' v' + note.version">
                          </vs-tab>
                        </vs-tabs>
                      </vs-row>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-w="5">
                    <vs-row class="mb-3">
                      <vs-col vs-w="5" class="mr-5">
                        <form-label>{{ $t('MRMR.Statement.Device') }}</form-label>
                        <ValidationProvider :name="$t('MRMR.Statement.Device')" rules="required" v-slot="{ errors }">
                        <v-select
                            label="name"
                            :options="devices"
                            v-model="model.device"
                            :reduce="d => d.id"
                            class="w-full"
                          />
                        <validation-message
                            >{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                    <vs-col vs-w="3" >
                      <ValidationProvider :name="$t('MRMR.Statement.FXRate')" rules="required|decimal:3|between:0,100" v-slot="{ errors }">
                        <validated-input
                          :label="$t('MRMR.Statement.FXRate')"
                          v-model="model.fxRate"
                        ></validated-input>
                          <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                      </vs-col>
                      <vs-col vs-w="3" vs-type="flex" vs-align="center">
                        <form-label class="mt-6 usd-equivalent">= 1$ USD</form-label>
                      </vs-col>
                    </vs-row>
                    <vs-divider position="center" class="mb-0">{{ $t('MRMR.ElementPrice.Title') }}</vs-divider>
                    <vs-row>
                      <vs-col class="tableCol pr-5 mr-5 border-right" vs-w="6">
                        <vs-row>
                          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-w="10">
                            <span>{{ getMetalPricesName(resourceCategoryEnum.Reserve) }}</span>
                          </vs-col>
                          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                            <feather-icon icon="PlusIcon" class="cursor-pointer" svg-classes="h-6 w-6"
                              @click="addElementPrice(resourceCategoryEnum.Reserve)" v-b-tooltip.hover
                              :title="$t('MRMR.ElementPrice.AddElement')" />
                          </vs-col>
                        </vs-row>
                        <vs-row>
                          <vs-list>
                          <vs-list-item v-for="(listItem, index) in reserveElementPrices" :key="index" :title="$t('Element.' + listItem.element) + ' - ' + listItem.price + ' $'">
                            <feather-icon icon="EditIcon" class="cursor-pointer mr-3" svg-classes="h-4 w-4" @click="editElementPrice(listItem)" v-b-tooltip.hover :title="$t('MRMR.ElementPrice.EditElement')"/>
                            <feather-icon icon="TrashIcon" class="cursor-pointer" svg-classes="h-4 w-4" @click="deleteElementPrice(listItem, resourceCategoryEnum.Reserve)" v-b-tooltip.hover :title="$t('MRMR.ElementPrice.DeleteElement')"/>
                            </vs-list-item>
                          </vs-list>
                        </vs-row>
                      </vs-col>
                      <vs-col class="tableCol" vs-w="5">
                        <vs-row>
                          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-w="10">
                            <span>{{ getMetalPricesName(resourceCategoryEnum.Resource) }}</span>
                          </vs-col>
                          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="end" vs-w="2">
                            <feather-icon icon="PlusIcon" class="cursor-pointer" svg-classes="h-6 w-6"
                              @click="addElementPrice(resourceCategoryEnum.Resource)" v-b-tooltip.hover
                              :title="$t('MRMR.ElementPrice.AddElement')" />
                          </vs-col>
                        </vs-row>
                        <vs-row>
                        <vs-list  >
                          <vs-list-item v-for="(listItem, index) in resourceElementPrices" :key="index" :title="$t('Element.' + listItem.element) + ' - ' + listItem.price + ' $'">
                            <feather-icon icon="EditIcon" class="cursor-pointer mr-3" svg-classes="h-4 w-4" @click="editElementPrice(listItem)" v-b-tooltip.hover :title="$t('MRMR.ElementPrice.EditElement')"/>
                            <feather-icon icon="TrashIcon" class="cursor-pointer" svg-classes="h-4 w-4" @click="deleteElementPrice(listItem, resourceCategoryEnum.Resource)" v-b-tooltip.hover :title="$t('MRMR.ElementPrice.DeleteElement')"/>
                            </vs-list-item>
                          </vs-list>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <div v-if="epEditMode">
                      <vs-row class="mb-5" vs-type="flex">
                        <vs-col vs-w="3" class="mr-3">
                        <form-label>{{$t('MRMR.ElementPrice.ResourceCategory')}}</form-label>
                        <ValidationProvider :name="$t('MRMR.ElementPrice.ResourceCategory')" rules="required" v-slot="{ errors }">
                          <v-select
                              label="name"
                              :options="resourceCategories"
                              v-model="epResourceCategory"
                              :reduce="e => e.id"
                              class="w-full"
                              :disabled="true"
                            />
                          <validation-message
                            >{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>
                        <vs-col vs-w="3" class="mr-3">
                          <form-label>{{$t('MRMR.ElementPrice.Element')}}</form-label>
                          <ValidationProvider :name="$t('MRMR.ElementPrice.Element')" rules="required" v-slot="{ errors }">
                            <v-select
                                label="name"
                                :options="filteredElements"
                                v-model="epElement"
                                :reduce="e => e.id"
                                class="w-full"
                                :disabled="epUpdateMode"
                              />
                            <validation-message
                                >{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>
                        <vs-col vs-w="3" class="mr-3">
                        <ValidationProvider :name="$t('MRMR.ElementPrice.Price')" rules="required|decimal:3|between:0,10000" v-slot="{ errors }">
                          <validated-input
                            :label="$t('MRMR.ElementPrice.Price')"
                            v-model="epPrice"
                          ></validated-input>
                          <validation-message
                            >{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>

                      <vs-col vs-w="2" class="mt-5" >
                        <vs-button v-show="epCreateMode" @click="insertElementPrice" v-b-tooltip.hover :title="$t('Apply')">{{$t('Apply')}}</vs-button>
                        <vs-button v-show="epUpdateMode" @click="updateElementPrice" v-b-tooltip.hover :title="$t('Apply')">{{$t('Apply')}}</vs-button>
                        </vs-col>
                      </vs-row>
                    </div>

                  </vs-col>
                </vs-row>
              </div>
            </vs-tab>
            <vs-tab value="1" :label="$t('MRMR.Statement.Tab2')" icon-pack="feather" icon="icon-calendar">
              <statement-lines
                ref="statementLines"
                :entries="model.entries"
                :previousStatements="previousStatements"
                :periodId="model.mrmrStatementPeriodId"
                @onAddEntry="addEntry"
                @onEditEntry="editEntry"
                @onDeleteEntry="deleteEntry"
                @onRestoreEntry="restoreEntry"
                @onDeleteEntries="deleteEntries"
              />
            </vs-tab>
          <vs-tab value="2" :label="$t('MRMR.Statement.Tab3')" icon-pack="feather" icon="icon-trending-up" v-b-tooltip.hover :title="isDirty ? $t('MRMR.Statement.ComparisonUnavailable') : ''" >
            <statement-comparison  :readOnly="false" :selectedStatement="model" v-if="!isDirty" />
            </vs-tab>
          </vs-tabs>
        </ValidationObserver>
      </vx-card>
    </div>
    <vs-popup class="uploadPopup" :title="$t('MRMR.Statement.UploadFile')" :active.sync="uploadPopupActive">
      <div class="p-6" v-if="!isNew">
        <form data-vv-scope="tab2">
          <vs-row class="mb-5">
            <vs-col class="text-warning" vs-w="12">
             <feather-icon
                  icon="AlertTriangleIcon"
                  class="mr-3"
                />
              {{ $t('MRMR.Statement.UploadWarning') }}
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <input id="uploadInputFile" type="file" accept=".csv" v-on:change="getFile($event)">
              <div class="mb-1">
              </div>
              <validation-message v-if="showInvalidFileError">{{ $t('MRMR.Statement.UploadInvalidFileError')
                }}</validation-message>
            </vs-col>
          </vs-row>
          <vs-row class="mb-6">
            <vs-col vs-w="6">
            <small><a target="_blank" href="https://agnicoeagle.sharepoint.com/:x:/s/GRP_CSD_Data_Solution/EQM5LIdJNotEsl_ogbpn_w8BZWPU8oq8VWmLK-su6E5xlA?e=fqxG9K&download=1">{{$t('MRMR.Statement.UploadTemplateVolumeFile')}}</a></small><br>
            <small><a target="_blank" href="https://agnicoeagle.sharepoint.com/:x:/s/GRP_CSD_Data_Solution/EYuJxCkdvwxIkx5SZFTpuXQBAT_JqMWGgVYd1bja4oyRXg?e=elkAK0&download=1">{{$t('MRMR.Statement.UploadTemplateTonnageFile')}}</a></small>
            </vs-col>
          </vs-row>
        </form>
        <div>
          <vs-row class="mb-3" vs-type="flex" vs-justify="flex-end">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-button :disabled="!file" class="mr-5" @click="uploadFile">{{ $t('Submit') }}</vs-button>
              <vs-button type="border" color="danger" @click="cancelUpload">{{ $t('Cancel') }}</vs-button>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <vs-progress v-show="uploadInProgress" indeterminate color="primary">primary</vs-progress>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <div v-else>
        {{ $t('MRMR.Statement.StatementMustBeCreated') }}
      </div>
    </vs-popup>
  </div>
</template>

<script>

import router from '../../../../router'
// import draggable from 'vuedraggable'
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import StatementLines from './components/StatementLines.vue'
import StatementComparison from './components/StatementComparison.vue'
import EntrySideView from './components/EntrySideView.vue'
import moduleMRMR from "../store/moduleMRMR.js";
import DeviceEnum from "../DeviceEnum.js";
import ResourceCategoryEnum from "../ResourceCategoryEnum.js";
import ElementEnum from "@/app/shared/ElementEnum.js"
import qpOccupationsEnum from "../QPOccupationEnum";
import {
  // FormLabel,
  ValidatedInput,
  ValidationMessage,
  FormLabel
} from "../../../shared/components";
import featureFlagsService from '@/app/shared/services/featureFlagsService.js'
import features from "@/app/shared/AppFeatures.js"
import MiningTypeEnum from "../MiningTypeEnum.js";

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    vSelect,
    StatementLines,
    StatementComparison,
    EntrySideView,
    Datepicker
  },
  data() {
    return {
      // statementId represents the id passed in as the params to the view
      statementId: 0,
      // when we have a statement loaded we then use model.id
      model: {
        id: 0,
        version: 1,
        qpEngineering: "",
        qpGeology: "",
        engineerQPId: null,
        geologistQPId: null,
        projectId: null,
        mrmrStatementPeriodId: null,
        ownership: 100,
        coreLoggingDatabaseClosureDate: null,
        device: DeviceEnum.USD,
        fxRate: 1,
        notes: "",
        entries: [],
        elementPrices: [],
        metallurgicalRecoveries: []
      },
      resourceCategoryEnum: ResourceCategoryEnum,
      statementCoreLoggingDatabaseClosureDate: null,
      previousStatements: [],
      previousStatementId: null,
      statementUnknownQpEngineering: false,
      statementUnknownQpGeology: false,
      epUpdateMode: false,
      epCreateMode: false,
      epElement: null,
      epPrice: 0,
      epSelectedElement: null,
      epResourceCategory: 1,
      selectedTab: 0,
      sideBarEntryData: {},
      entrySidebarActive: false,
      uploadPopupActive: false,
      showInvalidFileError: false,
      uploadInProgress: false,
      file: "",
      isDirty: false,
      selectedNotesVersion: 1,
      selectedNoteIndex: 0,
      devices: [
        { id: DeviceEnum.USD, name: this.$t("MRMR.Devices." + DeviceEnum.USD) },
        { id: DeviceEnum.CAD, name: this.$t("MRMR.Devices." + DeviceEnum.CAD) },
        { id: DeviceEnum.EUR, name: this.$t("MRMR.Devices." + DeviceEnum.EUR) },
        { id: DeviceEnum.MXN, name: this.$t("MRMR.Devices." + DeviceEnum.MXN) },
        { id: DeviceEnum.AUD, name: this.$t("MRMR.Devices." + DeviceEnum.AUD) }
      ],
      elements: [
        { id: ElementEnum.Gold, name: this.$t("Element." + ElementEnum.Gold) },
        { id: ElementEnum.Silver, name: this.$t("Element." + ElementEnum.Silver) },
        { id: ElementEnum.Copper, name: this.$t("Element." + ElementEnum.Copper) },
        { id: ElementEnum.Zinc, name: this.$t("Element." + ElementEnum.Zinc) },
        { id: ElementEnum.Lead, name: this.$t("Element." + ElementEnum.Lead) }
      ],
      resourceCategories: [
        { id: ResourceCategoryEnum.Reserve, name: this.getResourceCategoryName(ResourceCategoryEnum.Reserve) },
        { id: ResourceCategoryEnum.Resource, name: this.getResourceCategoryName(ResourceCategoryEnum.Resource) }
      ],
      footnotesPopupActive: false,
      miningTypeEnum: MiningTypeEnum
      
    };
  },
  watch: {
    statementUnknownQpEngineering(val) {
      if (val) {
        this.model.qpEngineering = null;
        this.model.engineerQPId = null;
      }
    },
    statementUnknownQpGeology(val) {
      if (val) {
        this.model.qpGeology = null;
        this.model.geologistQPId = null;
      }
    }
    // 'model.metallurgicalRecoveries': {
    //   handler (after) {
    //     after.forEach((item) => {
    //       if (item.nonApplicable) {
    //         item.percentage = null;
    //       }
    //     });
    //   },
    //   deep: true
    // }
  },
  computed: {
    isNew() {
      return this.model !== undefined && this.model.id === 0;
    },
    periods() {
      return this.$store.state.mrmr.periods;
    },
    cardTitle() {
      if (!this.isNew)
        return this.statementFullName;
      else
        return this.$t('MRMR.Statement.New');
    },
    statementFullName() {
      const project = this.$store.state.mrmr.projects.find(p => p.id === this.model.projectId);
      const period = this.$store.state.mrmr.periods.find(p => p.id === this.model.mrmrStatementPeriodId);
      if (project === undefined || period === undefined) {
        return "";
      }
      return `${project.name} - ${period.name} - v${this.model.version}`;

    },

    sortedPeriods() {
      const list = this.periods;
      return list.sort((a, b) => { return (a.periodDate < b.periodDate) ? -1 : 1 });
    },
    projects() {
      if (featureFlagsService.isEnabled(features.Core.ProjectFilter.Corporate)) {
        return this.$store.state.mrmr.projects;
      } else {
        return this.$store.state.authorizedProjects.map(obj => {
          return {
            id: parseInt(obj.id),
            name: obj.name
          }
        });
      }
    },
    previousStatementList() {
      const values = this.previousStatements.map(obj => {
        return {
          id: obj.id,
          name: obj.period.name + ' - v' + obj.version
        }
      });
      return values;
    },
    selectedPreviousVersionNote() {
      const previousNote = this.versionsNotes.find(o => o.version === this.selectedNotesVersion);
      if (previousNote !== null && previousNote !== undefined) {
        return previousNote.notes;
      } else
        return '';
    },
    versionsNotes() {
      return this.previousStatements.filter(o => o.mrmrStatementPeriodId === this.model.mrmrStatementPeriodId).map(obj => {
        return {
          id: obj.id,
          version: obj.version,
          name: 'v' + obj.version,
          notes: obj.notes
        }
      });
    },
    allNoteVersions() {
      const allVersions = this.versionsNotes.map(obj => {
        return {
          version: obj.version,
          name: 'v' + obj.version
        }
      });
      allVersions.push({
        version: this.model.version,
        name: 'v' + this.model.version
      });

      return allVersions;
    },
    previousStatementEntries() {
      const statement = this.previousStatements.find(o => o.id === this.previousStatementId);
      if (statement !== null && statement !== undefined) {
        return statement.entries;
      }

      return [];
    },
    qpEngineers() {
      const list = this.$store.state.mrmr.qps;
      return list.filter(_ => _.occupation === qpOccupationsEnum.Engineer && _.allowedProjects.map(z => z.projectId).includes(this.model.projectId));
    },
    sortedQpEngineers() {
      const list = this.qpEngineers;
      return list.sort((a, b) => { return (a.name < b.name) ? -1 : 1 });    
    },
    qpEngineeringUsers() {
      return this.$store.state.mrmr.qpEngineeringUsers;
    },
    sortedQpEngineeringUsers() {
      const list = this.qpEngineeringUsers;
      return list.sort((a, b) => { return (a.displayName < b.displayName) ? -1 : 1 });
    },
    qpGeologists() {
      const list = this.$store.state.mrmr.qps;
      return list.filter(_ => _.occupation === qpOccupationsEnum.Geologist && _.allowedProjects.map(z => z.projectId).includes(this.model.projectId));
    },
    sortedQpGeologists() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const list = Array.from(this.qpGeologists);
      return list.sort((a, b) => { return (a.name < b.name) ? -1 : 1 });
    },
    qpGeologyUsers() {
      return this.$store.state.mrmr.qpGeologyUsers;
    },
    sortedGeologyUsers() {
      const list = Array.from(this.qpGeologyUsers);
      return list.sort((a, b) => { return (a.displayName < b.displayName) ? -1 : 1 });
    },
    epEditMode() {
      return this.epCreateMode || this.epUpdateMode;
    },
    sortedElementPrices() {
      const list = this.model.elementPrices;
      return list.sort((a, b) => { return (a.element < b.element) ? -1 : 1 });
    },
    resourceElementPrices() {
      return this.sortedElementPrices.filter(o => o.resourceCategory === ResourceCategoryEnum.Resource);
    },
    reserveElementPrices() {
      return this.sortedElementPrices.filter(o => o.resourceCategory === ResourceCategoryEnum.Reserve);
    },
    filteredElements() {
      if (this.epCreateMode === true) {
        const usedElement = this.model.elementPrices.filter(o => o.resourceCategory === this.epResourceCategory).map(r => r.element);
        return this.elements.filter(l => !usedElement.includes(l.id))
      } else if (this.epUpdateMode === true) {
        return this.elements.filter(l => l.id === this.epSelectedElement)
      } else {
        return this.elements;
      }

    }
  },
  created() {
    if (!moduleMRMR.isRegistered) {
      this.$store.registerModule("mrmr", moduleMRMR);
      moduleMRMR.isRegistered = true;
    }

    if (this.$route.params.editData !== undefined && this.$route.params.editData !== null) {
      this.statementId = this.$route.params.editData.id;
      this.refreshModel();
    } else if (this.$route.query.id !== undefined && this.$route.query.id !== null) {
      this.statementId = this.$route.query.id;
      this.refreshModel();
    } else {
      this.initMetallurgicalRecoveries();
    }
  },
  mounted() {
    if (this.$store.state.mrmr.periods.length === 0) {
      this.$vs.loading();

      Promise.all([
        this.$store.dispatch("mrmr/fetchPeriodListItems"),
        this.$store.dispatch("mrmr/fetchAllProjects")
      ]).finally(() => {
        this.$vs.loading.close();
      });
    }
  },

  methods: {
    showFootnotesInstructions() {
      this.footnotesPopupActive = true;
    },
    getResourceCategoryName(value) {
      return this.$t("MRMR.ResourceCategories." + value);
    },
    getMetalPricesName(value) {
      return this.$t("MRMR.MetalPrices." + value);
    },
    refreshModel() {
      this.isDirty = false;
      this.$vs.loading();
      Promise.all([
        this.getCurrentVersion(),
        this.getPreviousVersions()
      ]).finally(() => {
        this.$vs.loading.close();
        this.setDefaultNoteVersionIndex();

      })
    },
    openUploadPopup() {
      this.uploadPopupActive = true;
    },
    getFile(event) {
      if (event.target.files.length > 0) {
        if (event.target.files[0].name !== null && event.target.files[0].name !== "undefined") {
          if (event.target.files[0].name.search(".csv") !== -1) {
            this.file = event.target.files[0];
            this.showInvalidFileError = false;
          }
          else {
            this.showInvalidFileError = true;
          }
        }
      }
    },
    setDefaultNoteVersionIndex() {
      const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
      };

      sleep(100).then(() => {
        this.selectedNoteIndex = this.model.version - 1;
        this.selectedNotesVersion = this.model.version;
      });

    },
    getCurrentVersion() {
      this.$cqrsGet("geo/mrmr/statements/findLatest", { params: { id: this.statementId } }).then((response) => {
        this.model = JSON.parse(JSON.stringify(response.data.model));
        if (this.model.isSubmitted) {
          router.push("/mrmr/statements");
        }
        this.statementUnknownQpEngineering = (this.model.qpEngineering === null || this.model.qpEngineering === "") && this.model.engineerQPId === null;
        this.statementUnknownQpGeology = (this.model.qpGeology === null || this.model.qpGeology === "") && this.model.geologistQPId === null;
        this.selectedNotesVersion = this.model.version;
        this.initMetallurgicalRecoveries();
      });
    },
    initMetallurgicalRecoveries() {
      for (const element in ElementEnum)
      {
        if (isNaN(ElementEnum[element])) continue;
        const metallurgicalRecovery = this.model.metallurgicalRecoveries.find(e => e.element === ElementEnum[element]);
        if (metallurgicalRecovery === undefined) {
          this.model.metallurgicalRecoveries.push({
            element: ElementEnum[element],
            percentage: null,
            nonApplicable: ElementEnum[element] !== ElementEnum.Gold,
            miningType: MiningTypeEnum.OpenPit
          });
          this.model.metallurgicalRecoveries.push({
            element: ElementEnum[element],
            percentage: null,
            nonApplicable: ElementEnum[element] !== ElementEnum.Gold,
            miningType: MiningTypeEnum.Underground
          });
        }
      }
    },
    getPreviousVersions() {
      this.$cqrsGet("geo/mrmr/statements/FindAllPrevious", { params: { id: this.statementId } }).then((response) => {
        this.previousStatements = response.data.model;
        const previousStatement = this.previousStatements.find(o => o.mrmrStatementPeriodId !== this.model.mrmrStatementPeriodId);
        if (previousStatement !== undefined) {
          this.previousStatementId = previousStatement.id;
        }
      });
    },
    toggleDataSidebar(val = false) {
      this.entrySidebarActive = val;
    },
    returnToList() {
      router.push("/mrmr/statements");
    },
    initValues() {
      if (this.data.id) return;
      this.model.id = 0;
      this.model.version = 1;
      this.model.projectId = null;
      this.model.mrmrStatementPeriodId = null;
      this.model.qpEngineering = "";
      this.model.qpGeology = "";
      this.model.engineerQPId = null;
      this.model.geologistQPId = null;
      this.model.ownership = 100;
      this.model.coreLoggingDatabaseClosureDate = null;
      this.model.device = DeviceEnum.USD;
      this.model.fxRate = 1;
      this.model.notes = "";
      this.model.entries = [];
      this.model.elementPrices = [];
      this.model.metallurgicalRecovery = null;
      this.model.metallurgicalRecoveryNonApplicable = false;
      this.selectedTab = 0;
    },
    addEntry() {
      this.sideBarEntryData = {};
      this.toggleDataSidebar(true);
    },
    editEntry(entry) {
      this.sideBarEntryData = entry;
      this.toggleDataSidebar(true);
    },
    deleteEntry(index) {
      this.model.entries.splice(index, 1);
      this.isDirty = true;
    },
    restoreEntry(entry) {
      this.model.entries.push(entry)
    },
    deleteEntries(indexes) {

      indexes.sort(function (a, b) { return a - b; });

      for (let i = indexes.length - 1; i >= 0; i--)
        this.model.entries.splice(indexes[i], 1);

      this.isDirty = true;
    },
    entryInserted(entry) {
      this.model.entries.unshift(entry);
      this.toggleDataSidebar(false);
      this.isDirty = true;
    },
    entryUpdated(entry) {
      const entryIndex = this.model.entries.findIndex((t) => t.id === entry.id)
      this.model.entries.splice(entryIndex, 1, entry)
      this.toggleDataSidebar(false);
      this.isDirty = true;
    },
    insertElementPrice() {
      if (this.epElement === null)
        return;

      const newElementPrice = {
        mrmrStatementHeaderId: this.model.id,
        element: this.epElement,
        price: this.epPrice,
        resourceCategory: this.epResourceCategory
      };

      this.model.elementPrices.push(newElementPrice);
      this.epCreateMode = false;
    },
    updateElementPrice() {
      if (this.epSelectedElement === null)
        return;

      const index = this.model.elementPrices.findIndex(e => e.element === this.epSelectedElement && e.resourceCategory === this.epResourceCategory);
      if (index === -1)
        return;

      this.model.elementPrices[index].price = this.epPrice;

      this.epUpdateMode = false;
      this.epSelectedElement = null;
    },
    editElementPrice(range) {
      this.epElement = range.element;
      this.epPrice = range.price;
      this.epSelectedElement = range.element;
      this.epResourceCategory = range.resourceCategory;
      this.epCreateMode = false;
      this.epUpdateMode = true;
    },
    addElementPrice(resourceCategory) {
      this.epCreateMode = true;
      this.epUpdateMode = false;
      this.epElement = null;
      this.epPrice = 0;
      this.epSelectedElement = null;
      this.epResourceCategory = resourceCategory;
    },
    deleteElementPrice(element) {
      const index = this.model.elementPrices.findIndex(e => e.element === element.element && e.resourceCategory === element.resourceCategory);
      if (index === -1)
        return;

      this.model.elementPrices.splice(index, 1);
    },
    saveDataAsync() {
      return new Promise((resolve, reject) => {
        if (!this.isNew) {
          this.$store.dispatch("mrmr/updateStatement", this.model).then((response) => { resolve(response.data.model) })
            .catch((error) => {
              reject(error)
            })
        } else {
          this.$store.dispatch("mrmr/addStatement", this.model).then((response) => { resolve(response.data.model) })
            .catch((error) => {
              reject(error)
            })
        }
      })
    },
    saveData() {
      this.$refs.observer.validate().then(result => {
        const wasNew = this.isNew;
        if (result) {
          this.$vs.loading();
          this.saveDataAsync().then((obj) => {
            this.model = obj;
            if (!wasNew) {
              this.$notifySaveSuccess();
            }
            else {
              this.$vs.notify({
                title: this.$t("Success"),
                text: this.$t("InsertSuccess"),
                color: "success",
                iconPack: 'feather',
                icon: 'icon-check'
              });

              this.statementId = obj.id;
              this.refreshModel();
            }
          }).finally(() => {
            this.$vs.loading.close();
          })
        }
      });
    },
    uploadFile() {
      if (!this.isNew) {
        const formData = new FormData();
        formData.append("files", this.file);
        formData.append("id", this.model.id);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        this.uploadInProgress = true;
        this.$cqrsPost('geo/mrmr/statements/upload/', formData, config)
          .then((response) => {
            if (response.status === 200) {
              this.uploadInProgress = false;
              this.uploadPopupActive = false;
              this.$notifySuccess(this.$t('MRMR.Statement.UploadSuccess'));

              this.refreshModel();
            }
          }).catch((error) => {
            if (error.response.status === 400) {
              this.uploadInProgress = false;
              this.uploadPopupActive = false;
              this.$vs.notify({
                color: "danger",
                title: this.$t("MRMR.Statement.UploadFails"),
                text: error.response.data.Message
              });
            }
            this.refreshModel();
          }).finally(() => {
            document.getElementById("uploadInputFile").value = "";
            this.file = null;
          })
      }
    },
    cancelUpload() {
      document.getElementById("uploadInputFile").value = "";
      this.file = null;
      this.uploadPopupActive = false;
    },
    confirmSubmit() {
      this.$refs.observer.validate().then(result => {
        if (!result) {
          this.$notifyError(this.$t('MRMR.Statement.InvalidData'));
        }
        else if (this.model.notes === null || this.model.notes === "") {
          this.$vs.dialog({
            type: "confirm",
            color: "warning",
            title: this.$t('MRMR.Statement.NoComment'),
            text: this.$t('MRMR.Statement.ConfirmNoComments'),
            accept: this.submitStatement
          })
        } else {
          this.$vs.dialog({
            type: "confirm",
            color: "primary",
            title: this.$t('Save'),
            text: this.$t('MRMR.Statement.ConfirmSubmission'),
            accept: () => {
              this.submitStatement();
            }
          });
        }        
      });      
    },
    submitStatement() {
      if (!this.isNew) {

        this.$vs.loading();
        this.saveDataAsync().then(() => {
          this.$cqrsPost('geo/mrmr/statements/submit/', { id: this.model.id })
            .then(() => {
              this.$notifySuccess(this.$t('MRMR.Statement.SubmitSuccess'));
              this.$vs.loading.close();
              router.push("/mrmr/statements");
            })
        }).catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        })
      }
    },
    onNotesVersionClicked(version) {
      this.selectedNotesVersion = version;
    },
    initMetallurgicalRecovery(element) {
      return {
        percentage: 0,
        nonApplicable: false,
        element
      };
    },
    metallurgicalRecoveryRules(item) {
      if (item.nonApplicable) {
        return "";
      } else {
        return "required|decimal:2|between:0.01,100";
      }
    },
    getElementName(element) {
      return this.$t("Element." + element);
    }
  }
};
</script>
<style lang="scss" scoped>
.list-scrollable {
  height: 500px;
  /* or any height you want */
  overflow-y: auto;
}

.notes-mb-none {
  margin-bottom: 0px;
}

.notes-read-only {
  color: black;
  background-color: rgb(248, 248, 248);
}

.usd-equivalent {
  font-size: 14px;
}

.border-right {
  border-right: 2px solid rgba(0, 0, 0, 0.1);
}

.tableCol {

  .vs-table--header {
    display: flex;
    flex-wrap: wrap;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    >span {
      display: flex;
      flex-grow: 1;
    }
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;
    width: 200px;

    tr {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
      width: 200px;

      td {
        padding: 20px;

        &:first-child {
          border-top-left-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
        }

        &:last-child {
          border-top-right-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
        }
      }

      td.td-check {
        padding: 20px !important;
      }
    }
  }

  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;
      width: 200px;

      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }

    th.td-check {
      padding: 0 15px !important;
    }

    tr {
      background: none;
      box-shadow: none;
      width: 200px;

    }
  }

  .vs-table--tbody-table {
    min-width: 200px;
  }
}
.metallurgical-recovery {
  display: flex;
  float:inline-start;
  width:100px
}

</style>